import axios, { AxiosInstance } from "axios";

export const baseURL:any = process.env.REACT_APP_BASE_URL;

export const apiCall = () => {
  const instance: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    env: {
      // The FormData class to be used to automatically serialize the payload into a FormData object
      FormData: globalThis?.FormData,
    },
  });

  // Set up axios request interceptors
  instance.interceptors.request.use(
    function (config: any) {
      config.baseURL = process.env.REACT_APP_BASE_URL;
      let token = "";

      if (typeof (config?.headers as any).authorization === "undefined") {
        const tokenModel = JSON.parse(
          localStorage.getItem("CIPM-Auth") || "{}"
        );

        if (tokenModel?.Token) {
          token = tokenModel?.Token;
        }
      }

      config.headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "X-XSS-Protection": "1; mode=block",
        "Content-Type": "application/json",
        "Cross-Origin-Embedder-Policy": "require-corp",
        "Content-Security-Policy":
          "script-src 'self' 'unsafe-inline' kit.fontawesome.com code.jquery.com cdn.jsdelivr.net embed.tawk.to static-v.tawk.to stackpath.bootstrapcdn.com cdn.datatables.net pharmmall.azurewebsites.net https://standard.paystack.co https://merchant-api.staging.cyberpay.ng",
        "X-Frame-Options": "SAMEORIGIN",
        "X-Content-Type-Options": "nosniff",
        "Strict-Transport-Security": "max-age=31536000",
        "Feature-Policy":
          "accelerometer 'none'; gyroscope 'none'; magnetometer 'none'; microphone 'none'; usb 'none'",
        "Cache-Control": "no-cache",
        "Cross-Origin-Opener-Policy": "same-origin",
        Pragma: "no-cache",
      };

      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  // Axios Response Interceptor
  instance.interceptors.response.use(
    function (config) {
      return config;
    },
    function (error) {
      if (updateOnlineStatus() === "offline") {
        error = {
          message:
            "You are currently offline. Kindly turn on your network or try again",
        };
        return Promise.reject(error);
      }

      if (error?.response?.status === 401) {
        localStorage.removeItem("CIPM-Auth");
        window.location.replace("/");
      }

      return Promise.reject(error);
    }
  );

  function updateOnlineStatus() {
    return navigator.onLine ? "online" : "offline";
  }

  window.addEventListener("offline", updateOnlineStatus);
  window.addEventListener("online", updateOnlineStatus);

  return instance;
};

export default apiCall;

export const downloadApi = async (
  url: any,
  method: string = "GET",
  body: any = {},
  config: any = { "Content-Type": "application/json" },
  download: boolean = false
) => {
  let res;
  const tokenModel = JSON.parse(localStorage.getItem("token") || "null");
  let token = tokenModel?.Token || tokenModel || "";

  if (!token) {
      console.error("🚨 No token found! Unauthorized request.");
      throw new Error("Unauthorized: No token found.");
  }

  config.Authorization = `Bearer ${token}`;

  try {
      res = await fetch(`${baseURL}${url}`, {
          method,
          headers: { ...config },
          body: method !== "GET" ? JSON.stringify(body) : undefined,
      });

      // If the response is OK and we're downloading a file, return a Blob
      if (download && res.ok) {
          return await res.blob();
      }

      // If the response is not OK, try to parse JSON for error messages
      const text = await res.text();
      if (!text) {
          throw new Error("Empty response from server");
      }

      try {
          return JSON.parse(text); // Try parsing JSON
      } catch (err) {
          throw new Error("Invalid JSON response: " + text);
      }
  } catch (error) {
      console.error("🚨 Fetch Error:", error);
      throw error;
  }
};


// export const downloadApi = async (url:any,method:string="GET",
//     body:any={},config:any={"Content-Type":"application/json"},download:boolean=false) =>{
//     let res ;
//     const tokenModel = JSON.parse(localStorage.getItem('token') || 'null');
//     let token = '';
//     if (tokenModel?.Token) {
//         token = tokenModel?.Token; 
//     }
//     const Authorization = `Bearer ${token}`;
//     config.Authorization = Authorization;

//     if(method.toLowerCase() === "get"){
//         res = await fetch(`${baseURL}${url}`,{
//             method,
//             headers:{
//                 ...config
//             }
//         })
//     }
//     else{
//         res = await fetch(`${baseURL}${url}`,{
//             method,
//             headers:{
//                 ...config
//             },
//             body
//         })
//     }
    
    
//     let data:any
//     if(download){
//         if(res.status === 200 && res.ok){
//             data = await res.blob();
//         }
//         else{
//             data = await res.json();
//         }
//         return data;
        
        
//     }
//     data = await res.json();
//     return data || res;
// }
